import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "web-re-take",
    templateUrl: "./re-take.component.html",
    styleUrls: ["./re-take.component.scss"],
})
export class ReTakeComponent {
    stage: string = "PROFILE_PENDING";

    constructor(private router: Router) {}

    ngOnInit() {
        this.stage = history.state?.stage || this.stage;
    }

    reTakePicture() {
        this.router.navigate(["/loan/re-take-picture"]);
    }
}
